import { Company, Instructor, Interest, User, UserTeam } from "../entities";
import { Content } from "../../../infrastructure/presentation/views/content/helpers";

/** Contains all the information about class. Used to users enroll in. */
//Graduation === TrainingCourse
export class TrainingCourse {
  id: number;

  title: string;

  description: string;

  imageURL: string;

  isActive: boolean;

  haveCertification: boolean;

  certificatePath: string;

  location: string;

  isPublic: boolean;

  maxCapacity: number;

  scheduleStart: string;

  scheduleEnd: string;

  scheduleStartDateTime: string;

  scheduleEndDateTime: string;

  enrollmentStart: string;

  enrollmentEnd: string;

  startedAt: string;

  finishedAt: string;

  duration: number;

  activationDate: string;

  inactivationDate: string;

  users: User[];

  instructors: Instructor[];

  userCertificateUrl: string;

  hasNewContent: boolean;

  image: string;

  imageB64: string;

  imageExtension: string;

  bannerURL: string;

  bannerBase64: string;

  bannerExtension: string;

  menuMarkdown: string;

  menus: Menu[];

  constructor(
    id: number = 0,
    title: string = "",
    description: string = "",
    imageURL: string = "",
    isActive: boolean = false,
    location: string = "",
    isPublic: boolean = false,
    maxCapacity: number = 0,
    scheduleStart: string = "",
    scheduleEnd: string = "",
    scheduleStartDateTime: string = "",
    scheduleEndDateTime: string = "",
    enrollmentStart: string = "",
    enrollmentEnd: string = "",
    startedAt: string = "",
    finishedAt: string = "",
    activationDate: string = "",
    inactivationDate: string = "",
    duration = 0,
    users: User[] = [],
    instructors: Instructor[] = [],
    userCertificateUrl: string = "",
    hasNewContent = false,
    haveCertification = false,
    certificatePath: string = "",
    image = "",
    imageB64: string = "",
    imageExtension: string = "",
    bannerURL: string = "",
    bannerBase64: string = "",
    bannerExtension: string = "",
    menuMarkdown: string = "",
    menus: Menu[] = []
  ) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.imageURL = imageURL;
    this.isActive = isActive;
    this.haveCertification = haveCertification;
    this.certificatePath = certificatePath;
    this.location = location;
    this.isPublic = isPublic;
    this.maxCapacity = maxCapacity;
    this.scheduleStart = scheduleStart;
    this.scheduleEnd = scheduleEnd;
    this.scheduleStartDateTime = scheduleStartDateTime;
    this.scheduleEndDateTime = scheduleEndDateTime;
    this.enrollmentStart = enrollmentStart;
    this.enrollmentEnd = enrollmentEnd;
    this.startedAt = startedAt;
    this.finishedAt = finishedAt;
    this.activationDate = activationDate;
    this.inactivationDate = inactivationDate;
    this.duration = duration;
    this.users = users;
    this.instructors = instructors;
    this.userCertificateUrl = userCertificateUrl;
    this.hasNewContent = hasNewContent;
    this.image = image;
    this.imageB64 = imageB64;
    this.imageExtension = imageExtension;
    this.bannerURL = bannerURL;
    this.bannerBase64 = bannerBase64;
    this.bannerExtension = bannerExtension;
    this.menuMarkdown = menuMarkdown;
    this.menus = menus;
  }
}

export class TrainingCourseRequest {
  companies: Company[];

  contents: Content[];

  graduation: TrainingCourse;

  instructors: Instructor[];

  interests: Interest[];

  teams: UserTeam[];

  users: User[];

  constructor(
    companies: Company[] = [],
    contents: Content[] = [],
    graduation: TrainingCourse = new TrainingCourse(),
    instructors: Instructor[] = [],
    interests: Interest[] = [],
    teams: UserTeam[] = [],
    users: User[] = []
  ) {
    this.companies = companies;
    this.contents = contents;
    this.graduation = graduation;
    this.instructors = instructors;
    this.interests = interests;
    this.teams = teams;
    this.users = users;
  }
}

export class Menu {
  public id: number;
  public description: string;
  public descriptionMarkdown: string;
  public startDate: string;
  public startHour: string;
  public endHour: string;
  public duration: number | null;
  public title: string;
  public location: string;

  constructor(
    id = NaN,
    description = "",
    descriptionMarkdown = "",
    startDate = "",
    startHour = "",
    endHour = "",
    duration = null,
    title = "",
    location = ""
  ) {
    this.id = id;
    this.description = description;
    this.descriptionMarkdown = descriptionMarkdown;
    this.startDate = startDate;
    this.startHour = startHour;
    this.endHour = endHour;
    this.duration = duration;
    this.title = title;
    this.location = location;
  }
}
